import { Component, EventEmitter, Input, Output } from '@angular/core';
import {ANIMATION} from "../../../../constants/fields.constants";

@Component({
  selector: 'data-label',
  templateUrl: './data-label.component.html',
  styleUrls: ['./data-label.component.scss']
})
export class DataLabelComponent {
  @Input() label = undefined;
  @Input() subLabel = undefined;
  @Input() animation = ANIMATION;
  @Input() inContainer = true;

  @Input() iconClass = '';

  @Input() toolTip = undefined;
  @Input() icon = undefined;
  @Input() order = 2;
  @Input() class = '';
  @Input() active = false;

  @Output() click = new EventEmitter<boolean>(true);

  protected readonly undefined = undefined;
}
